require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-embracing-the-future-code-fellows-integrates-ai-into-tech-education.json") })
        }
      }, "path---blog-embracing-the-future-code-fellows-integrates-ai-into-tech-education");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-embracing-the-future-code-fellows-integrates-ai-into-tech-education!./.cache/json/blog-embracing-the-future-code-fellows-integrates-ai-into-tech-education.json
// module id = 790
// module chunks = 231608221292675